// extracted by mini-css-extract-plugin
export default {"crums":"Crums_crums__jxYfh","limited":"Crums_limited__zq52t","light":"Crums_light__w225c"};